import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbMigracao } from 'app/abstract/full-pages/migracao/migracao.abstract';

@Injectable({ providedIn: 'root' })
export class MigracaoService extends AbMigracao {

  constructor(http: HttpClient) {
    super(http);
  }

  public getDatasources() {
    return this.get('migracoes/datasources');
  }

  public migrar(body) {
    return this.post('migracoes', body);
  }

  public getLogs(idReferencia: number) {
    return this.get(`migracoes/logs/${idReferencia}`);
  }
}